import * as React from 'react'
import { withTheme } from 'styled-components'

class Root extends React.Component {
  componentDidMount() {
    // @ts-ignore
    const backgroundColor = this.props.theme.backgroundColor[this.props.theme.mode]
    // @ts-ignore
    const textColor = this.props.theme.textColor[this.props.theme.mode]

    document.body.style.backgroundColor = backgroundColor
    document.body.style.color = textColor
  }
  render() {
    return <div>{this.props.children}</div>
  }
}

export default withTheme(Root)



// WEBPACK FOOTER //
// ./src/components/Root/index.tsx